import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const Complaints = Loadable(lazy(() => import('views/Complaints')));
const Booking = Loadable(lazy(() => import('views/Booking')));
const RoomDetails = Loadable(lazy(() => import('views/RoomDetails')));
const AttendencePage = Loadable(lazy(() => import('views/AttendencePage')));
const StudentGatePass = Loadable(lazy(() => import('views/StudentGatePass')));
// const Feemanagment = Loadable(lazy(() => import('views/FeesManagement')));


// const PaymentSuccessPage = Loadable(lazy(() => import('views/FeesManagement/PaymentSuccessPage')));
// const StudentAddmission = Loadable(lazy(() => import('views/StudentAddmission')));


// ==============================|| MAIN ROUTING ||============================== //

const SubAdminRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        
        {
          path: 'complaints',
          element: <Complaints />
        },
        
        {
          path: 'attendance',
          element: <AttendencePage />
        },
        {
          path: 'Booking',
          element: <Booking />
        },
        // {
        //   path: 'feemanagment',
        //   element: <Feemanagment/>
        // },
        // {
        //   path: 'feemanagment/payment-success',
        //   element: <PaymentSuccessPage />
        // },
        {
          path: 'room_details',
          element: <RoomDetails />
        },
        {
          path: 'studentGatePass',
          element: <StudentGatePass />
        },
        // {
        //   path: 'studentAddmission',
        //   element: <StudentAddmission />
        // }
      ]
    }
  ]
};

export default SubAdminRoutes;
